import { capi } from "..";
import { MultisearchDTOin } from "./DTOs/multisearchDTOin";
import { MultisearchDTOout } from "./DTOs/multisearchDTOout";

export const multisearch = (multisearchDTOin: MultisearchDTOin): Promise<MultisearchDTOout> => {
    return capi.get(`/api/hadmin/multisearch/${multisearchDTOin.name}`);
}